import { supabase } from '../../lib/supabase/client'
import { TABLES } from '../../lib/supabase/contracts.full'

export type PlanExerciseSnapshot = {
  id: string
  exerciseId?: string | null
  name: string
  primaryMuscle?: string | null
  reps?: number | string | null
  restSeconds?: number | null
  sets?: number | null
  setType?: string | null
  setTypes?: string[] | null
  targetWeightKg?: number | null
  trackingType?: string | null
  groupId?: string | null
  groupType?: string | null
}

export type PlanDaySnapshot = {
  id: string
  name: string
  weekday?: number | string | null
  exercises: PlanExerciseSnapshot[]
}

export type PlanSnapshot = {
  schemaVersion?: number | string
  savedAt?: string
  days: PlanDaySnapshot[]
}

export type Plan = {
  id: string
  owner_id: string
  athlete_id: string | null
  name: string
  kind: string
  status: string
  scheduling_mode: string
  duration_weeks: number | null
  current_version_id: string | null
  activated_at: string | null
  ends_on: string | null
  completed_at: string | null
}

export async function listPlansForAthlete(athleteId: string): Promise<Plan[]> {
  const { data, error } = await supabase
    .from(TABLES.plans)
    .select('id,owner_id,athlete_id,name,kind,status,scheduling_mode,duration_weeks,current_version_id,activated_at,ends_on,completed_at')
    .or(`athlete_id.eq.${athleteId},and(athlete_id.is.null,owner_id.eq.${athleteId})`)
    .order('updated_at', { ascending: false })

  if (error) throw error
  return (data ?? []) as Plan[]
}

export async function getPlanSnapshot(plan: Plan): Promise<PlanSnapshot> {
  if (!plan.current_version_id) return { days: [] }

  const { data, error } = await supabase
    .from(TABLES.planVersions)
    .select('snapshot')
    .eq('id', plan.current_version_id)
    .eq('plan_id', plan.id)
    .single()

  if (error) throw error
  const snapshot = data.snapshot as Partial<PlanSnapshot> | null
  return { ...snapshot, days: Array.isArray(snapshot?.days) ? snapshot.days : [] }
}

export function isPlanExpired(plan: Plan, today = new Date()) {
  if (!plan.ends_on || plan.completed_at) return false
  const localToday = new Date(today.getFullYear(), today.getMonth(), today.getDate())
  return new Date(`${plan.ends_on}T00:00:00`).getTime() < localToday.getTime()
}
